import { InputMask } from "@react-input/mask";
import TooltipUI from "@UI/TooltipUI";
import { formatPhoneNumber } from "@utils";
import { useEffect, useState } from "react";
import Icon from "./img/icon.svg";

import "./style.scss";

const AB_3274 = ({
    inputPhoneRef,
    sendPhone,
    setSendPhone,
    setCodeValue,
    codeValue,
    inputFieldsState,
    error,
    maskType,
    handlePhone,
    handleClick,
    errorCode,
    setErrorCode,
    smsProviderType,
    shouldStopRef,
    setLoaderBtn,
    className = "",
    setTriggerIcon = () => {},
    setInputFieldsState = () => {},
    autoFocus = false,
}) => {
    const [focus, setFocus] = useState();
    const [focusMask, setFocusMask] = useState(false);
    const [timer, setTimer] = useState(59000);
    const [tooManyReq, setTooManyReq] = useState(false);

    useEffect(() => {
        if (smsProviderType === "pushMts") {
            setTimer(59000 * 2);
        }
    }, [smsProviderType]);

    useEffect(() => {
        if (!autoFocus) return;
        inputPhoneRef.current.value = "+7 (___) ___-__-__";
        setFocusMask(true);
    }, [autoFocus]);

    useEffect(() => {
        if (sendPhone) {
            const intervalId = setTimeout(() => {
                if (timer > 0) {
                    setTimer(timer - 1000);
                } else {
                    clearTimeout(intervalId);
                }
            }, 1000);

            return () => {
                clearTimeout(intervalId);
            };
        }
    }, [sendPhone, timer]);

    const handleCode = (e) => {
        e.persist();
        let val = e.target.value;

        setCodeValue((prev) => {
            let obj = { ...prev, [e.target.id]: val.slice(-1) };
            return obj;
        });

        let id = val == "" ? Number(e.target.id) : Number(e.target.id) + 1;
        let inp = document.getElementById(id);
        if (inp) inp.focus();
    };

    const onKeyDown = (e) => {
        let val = e.target.value;

        if (e.keyCode == 8) {
            let id = val !== "" ? Number(e.target.id) : Number(e.target.id) - 1;
            let inp = document.getElementById(id);
            setCodeValue((prev) => {
                let obj = { ...prev, [e.target.id]: "" };
                return obj;
            });

            if (inp) inp.focus();
        }
    };

    const pasteHandler = () => {
        navigator.clipboard
            .readText()
            .then((text) => {
                if (text && text.length == 6) {
                    const initObj = { 0: "", 1: "", 2: "", 3: "" };
                    const newObj = text.split("").reduce((acc, val, index) => {
                        acc[index] = val;
                        return acc;
                    }, initObj);
                    setCodeValue(newObj);
                }
            })
            .catch(() => {});
    };

    const inputsItems = [0, 1, 2, 3].map((idx) => {
        return (
            <input
                key={idx}
                id={idx}
                placeholder={focus === idx ? "" : "_"}
                type="number"
                value={codeValue[idx].toLocaleString()}
                onChange={handleCode}
                onKeyDown={onKeyDown}
                onPaste={pasteHandler}
                onFocus={() => {
                    setFocus(idx);
                    setErrorCode(false);
                }}
                onBlur={() => setFocus(false)}
                className={`verify-window__code-field ${errorCode ? "verify-window__code-field_error" : ""} ${className}`}
                minLength={1}
                maxLength={1}
                min={1}
                max={1}
            />
        );
    });

    const sec = (ms) => {
        ms = Math.max(0, ms);
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(seconds).padStart(2, "0");

        return `${formattedMinutes}:${formattedSeconds}`;
    };

    const onClickChangPhone = () => {
        setCodeValue({ 0: "", 1: "", 2: "", 3: "" });
        setSendPhone(false);
    };

    const renderVerifyBlock = () => {
        const cfg = providerConfig[smsProviderType || "smsMts"];
        if (!cfg) return null;

        return (
            <div className={`ab-3274 verify-window ${className}`}>
                <div className="verify-window__header">
                    <span className="verify-window__title">{cfg.title}</span>
                    <span className="verify-window__phone">{formatPhoneNumber(inputFieldsState.phone, true)}</span>

                    <div
                        className="verify-window__change-btn"
                        onClick={() => {
                            if (smsProviderType === "pushMts") {
                                setTimer(59000 * 2);
                            } else {
                                setTimer(59000);
                            }
                            onClickChangPhone();
                            setTooManyReq(false);
                            shouldStopRef.current = false;
                            setLoaderBtn(false);
                            setTriggerIcon((prev) => {
                                return { ...prev, phone: 1 };
                            });
                        }}
                    >
                        Исправить номер
                    </div>
                </div>

                <span className="verify-window__instruction">{cfg.text}</span>

                <div className={`verify-window__code-inputs ${error ? "verify-window__code-inputs_error" : ""}`}>{inputsItems}</div>

                {errorCode ? <span className="verify-window__error">{errorCode}</span> : null}

                <span className="verify-window__recall">
                    {tooManyReq ? (
                        cfg.extra || "Превышен лимит запросов"
                    ) : timer > 0 ? (
                        cfg.repeat(sec(timer))
                    ) : (
                        <div
                            className="verify-window__recall-btn"
                            onClick={() => {
                                setCodeValue({ 0: "", 1: "", 2: "", 3: "" });
                                document.querySelector(".verify-window__code-inputs")?.classList.remove("verify-window__code-inputs_error");
                                setTimer(59000);
                                setTooManyReq(true);
                                shouldStopRef.current = false;
                                setLoaderBtn(true);
                                handleClick(true);
                            }}
                        >
                            {cfg.repeatBtn}
                        </div>
                    )}
                </span>
            </div>
        );
    };

    return (
        <>
            {sendPhone ? (
                renderVerifyBlock()
            ) : (
                <div className={`ab-3274 phone-input ${error ? "phone-input_error" : ""} ${inputFieldsState.phone.length > 10 ? "phone-input_filled" : ""} ${className}`}>
                    <InputMask
                        autocomplete="new-password"
                        ref={inputPhoneRef}
                        onChange={handlePhone}
                        autoFocus={autoFocus}
                        mask={maskType}
                        showMask={focusMask}
                        replacement={{ _: /\d/ }}
                        className={`phone-input__field ${inputFieldsState.phone?.length > 1 ? "" : "phone-input__field_empty"} ${focusMask || inputFieldsState.phone.length ? "phone-input__field_focus" : ""}`}
                        id="phones"
                        onFocus={() => {
                            const stateDigits = inputFieldsState.phone && inputFieldsState.phone !== false ? String(inputFieldsState.phone).replace(/\D/g, "") : "";
                            const inputDigits = inputPhoneRef.current?.value?.replace(/\D/g, "") ?? "";

                            if (stateDigits.length > 1 && inputDigits !== stateDigits) {
                                inputPhoneRef.current.value = formatPhoneNumber(inputFieldsState.phone);
                            }

                            if (inputDigits.length > 1 || stateDigits.length > 1) {
                                setFocusMask(true);
                                return;
                            }

                            if (inputPhoneRef.current) {
                                inputPhoneRef.current.value = "+7 (___) ___-__-__";
                            }
                            setFocusMask(true);
                        }}
                        onBlur={() => {
                            setFocusMask(false);
                            if (!inputFieldsState.phone.length) {
                                inputPhoneRef.current.value = "";
                            }
                        }}
                    />
                    <label className="phone-input__label">Ваш номер телефона</label>
                    {/* {inputFieldsState.phone?.length > 1 ? (
                        <img
                            src={Icon}
                            className="phone-input__clear-icon"
                            onClick={() => {
                                setInputFieldsState((prev) => {
                                    return { ...prev, phone: false };
                                });
                                inputPhoneRef.current.value = "";
                                setFocusMask(false);
                            }}
                        />
                    ) : null} */}
                </div>
            )}
        </>
    );
};

const providerConfig = {
    smsMts: {
        title: "Мы отправили вам СМС на номер",
        text: "Введите код, который вам пришел",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".verify-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="verify-window__notcome">
                    <i />
                    <span>Не смогли доставить код</span>
                </div>
            </>
        ),
    },

    smsMtsRepeat: {
        title: "Мы позвоним вам на номер",
        text: "Примите звонок и введите код, который вам продиктует наш автоматический помощник",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".verify-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="verify-window__notcome">
                    <i />
                    <span>Не смогли доставить код</span>
                </div>
            </>
        ),
    },
    smsProsto: {
        title: "Мы позвоним вам на номер",
        text: (
            <>
                Введите код, который вам продиктует <br /> наш автоматический помощник
            </>
        ),
        repeat: (sec) => `Повторный звонок через ${sec}`,
        repeatBtn: "Повторный звонок",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".verify-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="verify-window__notcome">
                    <i />
                    <span>Телефон не подтвержден</span>
                </div>
            </>
        ),
    },

    pushMts: {
        title: "Подтвердите вход на телефоне, чтобы получить подарок, либо дождитесь смс.",

        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        // noCode: true,
    },
    smsProsto2: {
        title: "Мы отправили вам СМС на номер",
        text: "Введите код, который вам пришел",
        repeat: (sec) => `Повторный звонок через ${sec}`,
        repeatBtn: "Повторный звонок",
    },
};

export default AB_3274;
